import client from "./client";

export default {
    async getContributionHistory(filters) {
        return client.parseResponse(await client.get('/contribution-history', filters));
    },

    async getPaymentStatus(filters) {
        return client.parseResponse(await client.post('/checkout-request-status', filters));
    },

    async getPayments(filters) {
        return client.parseResponse(await client.get('/payments', filters));
    },

    async createPayments(data) {
        return client.parseResponse(await client.post('/payments', data))
    },

    async createPaymentRequest(data) {
        return client.parseResponse(await client.post('/payment-request', data))
    },

    async initiatePayment(data) {
        return client.parseResponse(await client.post('/initiate-payment', data))
    },

    async getPayment(id) {
        return client.parseResponse(await client.get('/payments/' + id));
    },

    async editPayment(data) {
        return client.parseResponse(await client.put('/payments/' + data.id, data))
    },

    async editPaymentFormData(data) {
        return client.parseResponse(await client.post('/payments/' + data.get('id') + "?_method=PUT", data, {
            contentType: 'application/x-www-form-urlencoded'
        }))
    },

    async deletePayment(data) {
        return client.parseResponse(await client.delete('/payments/' + data.id, data))
    },

    async downloadContributionHistoryReport(data) {
        return client.parseResponse(await client.get('/contribution-history-report', data, {responseType: 'blob'}))
    },

    async downloadPayments(data) {
        return client.parseResponse(await client.get('/download-payments-report', data))
    },

    async sendContributionHistoryEmail(data) {
        return client.parseResponse(await client.get('/email-contribution-history-report', data))
    },
    async initiateContributionRequest(data) {
        return client.parseResponse(await client.post('/initiate-payment', data))
    },

    async exportPaymentsReport(filters) {
        return client.parseResponse(await client.get('/export-payments', filters, {responseType: 'blob'}));
    },

    async downloadPaymentReceipt(id) {
        return client.parseResponse(await client.get('/payments/' + id + '/receipt', {}, {responseType: 'blob'}));
    },

    async emailPaymentReceipt(id) {
        return client.parseResponse(await client.post('/payments/' + id + '/email-receipt'));
    },

    async reversePayment(id, reason) {
        return client.parseResponse(await client.post('/payments/' + id + '/reverse', {reason}));
    }
}
